enum ReplayTeams {
  TEAM_0 = 0,
  TEAM_1 = 1,
}

export default ReplayTeams;
